module.exports = __webpack_public_path__ + "6a178098a50e5c0f8d00a8798813d539.webp";